import { useEffect, useRef } from "react";

const StarfieldCanvas = ({ density = 160, className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return undefined;
    const ctx = canvas.getContext("2d");
    let w = 0;
    let h = 0;
    let raf;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    const resize = () => {
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const spawn = () => ({
      x: Math.random() * (w || 1200),
      y: Math.random() * (h || 800),
      r: 0.3 + Math.random() * 1.3,
      vx: 0.015 + Math.random() * 0.05,
      alpha: 0.25 + Math.random() * 0.6,
      pulse: 0.3 + Math.random() * 1.2,
      phase: Math.random() * Math.PI * 2,
      warm: Math.random() < 0.12,
    });

    const stars = Array.from({ length: density }, spawn);
    let t = 0;

    const tick = () => {
      t += 0.016;
      ctx.clearRect(0, 0, w, h);
      for (const s of stars) {
        s.x += s.vx;
        if (s.x > w + 4) s.x = -4;
        const a = s.alpha * (0.6 + 0.4 * Math.sin(t * s.pulse + s.phase));
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = s.warm
          ? `rgba(255, 120, 60, ${Math.max(a, 0)})`
          : `rgba(200, 220, 255, ${Math.max(a, 0)})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    tick();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, [density]);

  return <canvas ref={ref} className={className} aria-hidden="true" />;
};

export default StarfieldCanvas;
